import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { Box, Input, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, Textarea, } from '@chakra-ui/react';
import FormItemWrapper from '../_layout/FormItemWrapper';
var InputField = forwardRef(function (_a, ref) {
    var _b;
    var name = _a.name, textarea = _a.textarea, label = _a.label, isRequired = _a.isRequired, error = _a.error, noTopSpace = _a.noTopSpace, helperText = _a.helperText, onValueChange = _a.onValueChange, props = __rest(_a, ["name", "textarea", "label", "isRequired", "error", "noTopSpace", "helperText", "onValueChange"]);
    var _c = React.useState(((_b = props.defaultValue) === null || _b === void 0 ? void 0 : _b.toString()) || ''), _ = _c[0], setValue = _c[1];
    var handleNumberInputChange = function (valueString) {
        setValue(valueString);
        onValueChange &&
            onValueChange({
                id: name,
                name: name,
                value: valueString
            });
    };
    var inputComponentFactory = function (type) {
        var sharedProps = {
            id: name,
            name: name,
            placeholder: props.placeholder,
            errorBorderColor: 'red.200',
            borderColor: 'primary',
            variant: 'outline',
            bg: 'white',
            size: 'md',
            isDisabled: props.isDisabled
        };
        var dict = {
            number: (React.createElement(NumberInput, __assign({}, sharedProps, { ref: ref }, { onChange: handleNumberInputChange, value: props.value }),
                React.createElement(NumberInputField, null),
                React.createElement(NumberInputStepper, null,
                    React.createElement(NumberIncrementStepper, null),
                    React.createElement(NumberDecrementStepper, null)))),
            textarea: (React.createElement(Textarea, __assign({ ref: ref }, sharedProps, { onChange: function (e) { return handleNumberInputChange(e.target.value); }, value: props.value }))),
            input: (React.createElement(Input, __assign({}, sharedProps, props, { ref: ref }, { onChange: function (e) { return handleNumberInputChange(e.target.value); } })))
        };
        return dict[type];
    };
    var inputComponentTypeFactory = function () {
        switch (true) {
            case props.type === 'number':
                return 'number';
            case !!textarea:
                return 'textarea';
            default:
                return 'input';
        }
    };
    return (React.createElement(Box, { className: "rf__input-field-wrapper", mt: 2, w: '100%' },
        React.createElement(FormItemWrapper, __assign({}, {
            name: name,
            label: label,
            isRequired: isRequired,
            error: error,
            noTopSpace: noTopSpace,
            helperText: helperText
        }), inputComponentFactory(inputComponentTypeFactory()))));
});
InputField.displayName = 'InputField';
export default InputField;
//# sourceMappingURL=InputField.js.map